import mutations from './partnerHierarchyImport.mutations'
import actions from './partnerHierarchyImport.actions'
import getters from './partnerHierarchyImport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
